import { gql } from '@apollo/client';

export const SEND_NOTIFICATION = gql`
  mutation ($sendNotificationArgs: SendNotificationArgs!) {
    sendNotification(sendNotificationArgs: $sendNotificationArgs){
        message
    }
  }
`